import React from 'react'
import { Box } from '@mui/material'
import useUIStore from '../../store/uiStore'
import Navbar from './Navbar'
import Sidebar from './Sidebar'

const Layout = ({ children }) => {
  const { drawerOpen, drawerWidth, isMobile } = useUIStore()

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Navbar */}
      <Navbar />
      
      {/* Sidebar - Only show on desktop when open */}
      {drawerOpen && !isMobile && <Sidebar />}
      
      {/* Mobile Sidebar */}
      {isMobile && <Sidebar />}
      
      {/* Main content - Full width */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: '100%',
          p: { xs: 1.5, sm: 2, md: 2.5 },
          mt: 8, // Height of navbar
          ml: 0, // No margin - full width
          transition: theme => theme.transitions.create(['margin-left'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.standard,
          }),
          backgroundColor: 'background.default',
          minHeight: 'calc(100vh - 64px)', // Subtract navbar height
          overflow: 'auto',
          position: 'relative'
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default Layout
